<ng-container *transloco="let t;">
  <ul *ngIf="values?.length > 0">
    <li *ngFor="let value of values">
      <span (click)="onCompetenceClicked(value)" role="link" class="pointer">
        <fa-icon *ngIf="value.selected !== true" [icon]="faSquare"></fa-icon>
        <fa-icon *ngIf="value.selected === true" [icon]="faCheckSquare"></fa-icon>
        {{ value.competence.getLang('name', transloco.getActiveLang()) }}
      </span>
    </li>
  </ul>
  <p *ngIf="values.length === 0">{{ t('partials.ac_competences.no_competences') }}</p>
</ng-container>
